import tree from "../../../components/tree.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import IPaginations from "../../../components/paginations.vue";
import { domainName, processFile } from "../../../utility/index"

export default {
    name: "ICEmpower",
    components: { tree, iTable, IPagination, IPaginations },
    data() {
        return {
            isCollapse: false,
            stateArrow: true,
            isSearch: true,
            formInline: {
                selectCarType: '',
                selectCarValue: '',
                terminalId: '',
                linkState: '',
                authorizeCountUpper: 300,
                authorizeCountLower: 0
            },
            optionsInput: [{
                value: '0',
                label: this.$t('common.all')
            }, {
                value: '1',
                label: this.$t('common.carId')
            }, {
                value: '2',
                label: this.$t('common.plateNum')
            }, {
                value: '3',
                label: this.$t('common.customNum')
            },
            {
                value: '4',
                label: this.$t('common.manufactureNum')
            }],
            height: '550',
            list: [], 
            option: {
                stripe: true, 
                border: true,
                loading: false, 
                highlightCurrentRow: false, 
                mutiSelect: true, 
                serialNumber: true, 
            },
            columns: [
                {
                    prop: "carId",
                    label: this.$t('common.carId'),
                    align: "center",
                },
                {
                    prop: "manufactureNum",
                    label: this.$t('common.manufactureNum'),
                    align: "center",
                    width: "150px"
                },
                {
                    prop: "customNum",
                    label: this.$t('common.customNum'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "plateNum",
                    label: this.$t('common.plateNum'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "terminalId",
                    label: this.$t('common.terminalId'),
                    align: "center",
                    width: "220px"
                },
                {
                    prop: "orgName",
                    label: this.$t('common.orgName'),
                    align: "center",

                },
                {
                    prop: "messageTime",
                    label: this.$t('common.messageTime'),
                    align: "center",
                    width: "240px"
                },
                {
                    prop: "linkState",
                    label: this.$t('common.linkState'),
                    align: "center",
                    render: (h, params) => {
                        return h('el-tag', {
                            props: { type: params.row.linkState == 1 ? 'success' : 'danger' }
                        }, params.row.linkState == 1 ? this.$t('common.onLine')  : this.$t('common.offLine') )
                    }

                },
                {
                    prop: "keyAuthorizeCount",
                    label: this.$t('DriverManagement.authorizes') ,
                    align: "center",

                }

            ],
            dialogOperateFormVisible: false,
            operates: {
                width: 100,
                fixed: "right",
                list: [
                    {
                        id: '1',
                        show: true,
                        icon: 'iconfont iconicon-chakanxq',
                        plain: true,
                        disabled: false,
                        method: (index, row) => {
                            this.terminalId = row.terminalId
                            this.dialogOperateFormVisible = true
                            this.getOperateList()
                        }
                    }
                ],
            },
            input: '',
            currentPage: 1, 
            pageSize: 10, 
            total: 1, 
            dialogFormVisible: false,
            formLabelWidth: '112px',
            rules: {
                terminalType: [
                    { required: true, message: this.$t('common.form.terminalType') , trigger: 'change' }
                ],
                groupId: [
                    { required: true, message: this.$t('common.form.groupId') , trigger: 'change' }
                ],
                keyId: [
                    { required: true, message: this.$t('common.form.keyId') , trigger: 'change' }
                ],
                sendContent: [
                    { required: true, message: this.$t('common.form.terminalId') , trigger: 'blur' }
                ],

            },
            form: {
                terminalId: '',
                authorizeType: '',
                authorizePower: '',
                driverNum: ''
            },
            driveList: [],
            selected: [],
            dialogSyncFormVisible: false,
            SyncRules: {},
            SyncForm: {
                terminalId: '',
                fingerGroupId: ''
            },
            fingerList: [],
            formTable: {
                driverNum: '',
                driverName: ''
            },
            authorizeList: [],
            authorizeHeight: '350px',
            authorizeColumns: [
                {
                    prop: "carId",
                    label: this.$t('common.carId'),
                    align: "center",
                },
                {
                    prop: "terminalId",
                    label: this.$t('common.terminalId'),
                    align: "center",
                    width: "140px"
                },
                {
                    prop: "driverNum",
                    label: this.$t('common.driverNum'),
                    align: "center",

                },
                {
                    prop: "driverName",
                    label: this.$t('common.driverName'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "authorizePowerStr",
                    label: this.$t('DriverManagement.authorizeType'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "createTime",
                    label: this.$t('common.createTime'),
                    align: "center",
                },
            ],
            authorizeOperates: {
                width: 100,
                fixed: "right",
                list: [
                ],
            },
            AuthorizeCurrentPage: 1, 
            AuthorizePageSize: 50, 
            AuthorizeTotal: 1, 
            terminalId: '',
            select: [],
            driverName: '',
            fingerGroupName: ''
        }
    },
    created() {
        
    },
    methods: {
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        initQuery(item) {
            this.id = item.id
            this.name = item.name
            this.getAuthorizaList()
        },
        nodeClick(val) {
            this.id = val.label
            this.name = val.value
            this.getAuthorizaList()
        },
        getAuthorizaList() {
            let param = {
                orgId: this.id,
                selectCarType: this.formInline.selectCarType,
                selectCarValue: this.formInline.selectCarValue,
                terminalId: this.formInline.terminalId,
                linkState: this.formInline.linkState,
                authorizeCountUpper: this.formInline.authorizeCountUpper,
                authorizeCountLower: this.formInline.authorizeCountLower,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
            }
            this.$store.dispatch('ICEmpower/GET_SELECTKEYAUTHORIZELIST', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        filterMethod(val) {
            this.driverName = val
            this.getDriveList()
        },
        getDriveList() {
            let param = {
                orgId: this.id,
                name: this.driverName,
                pageNum: 0,
                pageSize: 100,
            }
            this.$store.dispatch('DriverFile/GET_SELECTALLDRIVER', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.driveList = res.data.data.list
                    }
                }
            }).catch(err => { })
        },
        filterFingerMethod(val) {
            this.fingerGroupName = val
            this.getFingerList()
        },
        getFingerList() {
            let param = {
                orgId: this.id,
                fingerGroupName: this.fingerGroupName
            }
            this.$store.dispatch('FingerprintAuthorization/GET_SELECTCARFINGERWAREHOUSE', param).then(res => {
                if (res) {
                    console.log(res)
                    if (res.data.code == 200) {
                        this.fingerList = res.data.data
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.$refs.page.CommandCurrentPage = 1
            this.currentPage = 1
            this.getAuthorizaList()
        },
        onClear() {
            this.formInline = {
                selectCarType: '',
                selectCarValue: '',
                terminalId: '',
                linkState: '',
                authorizeCountUpper: 300,
                authorizeCountLower: 0
            }
            this.getAuthorizaList()
        },
        addSimple() {
            this.dialogFormVisible = true
            this.$nextTick(() => {
                this.$refs.form.resetFields()
                this.form.terminalId = this.selected[0].terminalId
            })
            this.getDriveList()
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let param = {
                        terminalId: this.form.terminalId,
                        authorizePower: this.form.authorizePower,
                        driverNum: this.form.driverNum
                    }
                    this.$store.dispatch('ICEmpower/GET_INSERTKEYAUTHORIZE', param).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success(this.$t('common.btn.addSuccess'))
                            this.dialogFormVisible = false;
                            this.getAuthorizaList();
                            this.closeDia();
                        } else {
                            this.$message.error(res.data.msg)
                        }

                    }).catch(err => { })


                } else {
                    return false;
                }
            });
        },
        cancle(formName) {
            this.dialogFormVisible = false;
            this.form = {
                terminalId: '',
                authorizePower: '',
                driverNum: ''
            }
        },
        closeDia() {
            this.form = {
                terminalId: '',
                authorizePower: '',
                driverNum: ''
            }
            this.dialogFormVisible = false;
        },
        Refresh() {
            let param = {
                terminalId: this.selected[0].terminalId,
            }
            this.$store.dispatch('ICEmpower/GET_REFRESHIC', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.$message.success(this.$t('common.btn.refreshSuccess'))
                        this.getAuthorizaList();
                    }
                }
            }).catch(err => { })
        },
        CancelSend() {
            this.$confirm(this.$t('common.btn.confirmClear'), this.$t('common.btn.hint'),
                {
                    cancelButtonText: this.$t('common.btn.cancel'),
                    confirmButtonText: this.$t('common.btn.confirm'),
                    type: 'warning'
                }).then(res => {
                    let param = {
                        terminalId: this.selected[0].terminalId,
                    }
                    this.$store.dispatch('ICEmpower/GET_CLEARICAUTHORIZE', param).then(response => {
                        if (response.data.code == 200) {
                            this.getAuthorizaList()
                            this.$message.success(this.$t('common.btn.clearSuccess'))
                        } else {
                            this.$message.error(response.data.msg)
                        }
                    }).catch(error => { })
                }).catch(err => {

                })
        },
        synchro() {
            this.dialogSyncFormVisible = true
            this.$nextTick(() => {
                this.$refs.SyncForm.resetFields()
                this.SyncForm.terminalId = this.selected[0].terminalId
            })
            this.getFingerList()
        },
        submitSyncForm(SyncFormName) {
            this.$refs[SyncFormName].validate((valid) => {
                if (valid) {
                    let param = {
                        terminalId: this.SyncForm.terminalId,
                        fingerGroupId: this.SyncForm.fingerGroupId
                    }
                    this.$store.dispatch('ICEmpower/GET_ICAUTHORIZE', param).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success(this.$t('common.btn.authSuccess'))
                            this.dialogSyncFormVisible = false;
                            this.getAuthorizaList();
                            this.closeSyncDia();
                        } else {
                            this.$message.error(res.data.msg)
                        }

                    }).catch(err => { })


                } else {
                    return false;
                }
            });
        },
        SyncCancle(SyncFormName) {
            this.dialogSyncFormVisible = false;
            this.SyncForm = {
                terminalId: '',
                fingerGroupId: ''
            }
        },
        closeSyncDia() {
            this.SyncForm = {
                terminalId: '',
                fingerGroupId: ''
            }
            this.dialogSyncFormVisible = false;
        },
        downCar() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/getExportExcel/exportKeyAuthorize?orgId=${this.id}&selectCarType=${this.formInline.selectCarType}&selectCarValue=${this.formInline.selectCarValue}&terminalId=${this.formInline.terminalId}&linkState=${this.formInline.linkState}&authorizeCountUpper=${this.formInline.authorizeCountUpper}&authorizeCountLower=${this.formInline.authorizeCountLower}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportKeyAuthorize?orgId=${this.id}&selectCarType=${this.formInline.selectCarType}&selectCarValue=${this.formInline.selectCarValue}&terminalId=${this.formInline.terminalId}&linkState=${this.formInline.linkState}&authorizeCountUpper=${this.formInline.authorizeCountUpper}&authorizeCountLower=${this.formInline.authorizeCountLower}`
                    location.href = url
                }
            }
        },

        getOperateList() {
            let param = {
                terminalId: this.terminalId,
                driverNum: this.formTable.driverNum,
                driverName: this.formTable.driverName,
                pageNum: this.AuthorizeCurrentPage,
                pageSize: this.AuthorizePageSize,
            }
            this.$store.dispatch('ICEmpower/GET_SELECTTERMINALAUTHORIZE', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.authorizeList = res.data.data.list
                        this.$refs.AuthorizePage.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        closeOperateDia() {
            this.dialogOperateFormVisible = false
        },
        Search() {
            this.$refs.AuthorizePage.CommandCurrentPage = 1
            this.AuthorizeCurrentPage = 1
            this.getOperateList()
        },
        Clear() {
            this.formTable = {
                driverNum: '',
                driverName: ''
            },
                this.getOperateList()
        },
        handleAuthorizeChange(val) {
            this.select = val
        },
        changeAuthorizeSize(item) {
            this.AuthorizePageSize = item.pageSize
            this.AuthorizeCurrentPage = item.pageNum
            this.getOperateList();
        },
        queryDetails() {
            this.$confirm(this.$t('common.btn.confirmDelete'), this.$t('common.btn.hint'),
                {
                    cancelButtonText: this.$t('common.btn.cancel'),
                    confirmButtonText: this.$t('common.btn.confirm'),
                    type: 'warning'
                }).then(res => {
                    let param = {
                        terminalId: this.select[0].terminalId,
                        driverNum: this.select.map(item => item.driverNum).join()
                    }
                    this.$store.dispatch('ICEmpower/GET_DELETEICAUTHORIZE', param).then(response => {
                        if (response.data.code == 200) {
                            this.getOperateList()
                            this.$message.success(this.$t('common.btn.deleteSuccess'))
                        } else {
                            this.$message.error(response.data.msg)
                        }
                    }).catch(error => { })
                }).catch(err => {

                })
        },

        down() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/getExportExcel/exportTerminalAuthorize?terminalId=${this.terminalId}&driverNum=${this.formTable.driverNum}&driverName=${this.formTable.driverName}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportTerminalAuthorize?terminalId=${this.terminalId}&driverNum=${this.formTable.driverNum}&driverName=${this.formTable.driverName}`
                    location.href = url
                }
            }
        },

        handleSelectionChange(val) {
            console.log(val)
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getAuthorizaList();
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}